// extracted by mini-css-extract-plugin
module.exports = {"checkBoxContainer":"styles_checkBoxContainer__l_UsJ","checkedIcon":"styles_checkedIcon__D0spH","smallCheckbox":"styles_smallCheckbox__1y77i","checkedBg":"styles_checkedBg__3pST2"};